import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { SITE_URLS } from '@constants/routes';
import { SIDE_BAR } from '@localisation/components';
import { connect } from 'react-redux';
import AccountBoxIcon from '@material-ui/icons/AccountBox';
import LockOpenIcon from '@material-ui/icons/LockOpen';
import { List, ListItem, ListItemText, ListItemIcon } from '@material-ui/core';
import useStyles from './styles';

const AccountSideBar: React.FC<ISideBarProps> = (props) => {
  const history = useHistory();
  const isPublicUser = props.account.toJS().isPublicUser;
  const classes = useStyles();

  const [ activePath, setActivePath ] = useState(history.location.pathname);

  const goToPath = (path: string) => {
    if (!isCurrentPath(path)) {
      setActivePath(path);
      history.push(path);
    }
  };

  const isCurrentPath = (path: string) => { 
    return path === activePath;
  };

  return (
    <List
      component="div"
      aria-labelledby="side-bar-nested-list"
      className={classes.root}
    >
      <ListItem
        component="button"
        button
        className={`${classes.mainListItem} ${isCurrentPath(SITE_URLS.ACCOUNT_INFO) && classes.listItemActive}`}
        onClick={()=> goToPath(SITE_URLS.ACCOUNT_INFO)}
      >
        <ListItemIcon
          className="main-item-icon"
        >
          <AccountBoxIcon />
        </ListItemIcon>
        <ListItemText
          disableTypography
          primary={SIDE_BAR.INFO}
        />
      </ListItem>
      <ListItem
        component="button"
        button
        className={`${classes.mainListItem} ${isCurrentPath(SITE_URLS.CHANGE_PASSWORD) && classes.listItemActive}`}
        onClick={()=> goToPath(SITE_URLS.CHANGE_PASSWORD)}
      >
        <ListItemIcon
          className="main-item-icon"
        >
          <LockOpenIcon />
        </ListItemIcon>
        <ListItemText
          disableTypography
          primary={SIDE_BAR.CHANGE_PWD}
        />
      </ListItem>
    </List>
    //     { isPublicUser &&
    //     <div
    //       className={isCurrentPath(SITE_URLS.ACCOUNT_SUB) ? 'active' : EMPTY_STRING}
    //       onClick={()=> goToPath(SITE_URLS.ACCOUNT_SUB)}
    //       onKeyDown={()=> goToPath(SITE_URLS.ACCOUNT_SUB)}
    //       role="presentation"
    //     >
    //       {SIDE_BAR.SUBSCRIPTIONS}
    //     </div> }
    //   </ul>
    // </div>
  );
};

interface ISideBarProps {
  account
}

interface ISideBarDispatchProps {
}

interface ISideBarStateProps {
  account
}

const mapStateToProps = (state) => ({
  account: state.getIn(['Account', 'accountInfo'])
});

const mapDispatchToProps = (dispatch) => ({

});

export default connect<ISideBarStateProps, ISideBarDispatchProps>(mapStateToProps, mapDispatchToProps)(AccountSideBar);